import { Card } from '@/components/ui/card';

// Reusable section title component
export const SectionTitle = ({ children }: { children: React.ReactNode }) => (
  <h3 className="text-base text-primary font-normal">{children}</h3>
);

export const SectionDescription = ({
  children,
}: {
  children: React.ReactNode;
}) => <div className="text-xs text-muted-foreground">{children}</div>;

export const SectionLeftColumn = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <div className="flex flex-col gap-1 col-start-1 py-4 px-6 justify-center ">
    {children}
  </div>
);

export const SectionRightColumn = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <div
    className={`flex flex-col gap-2 col-start-2 py-4 px-6 justify-center font-medium`}
  >
    {children}
  </div>
);

export const SectionRow = ({ children }: { children: React.ReactNode }) => (
  <div className="grid grid-cols-[1fr_1fr] gap-0 items-stretch justify-stretch">
    {children}
  </div>
);

export const SectionRowComparison = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <div className="grid grid-cols-[1fr_1fr_1fr] gap-0 items-stretch justify-stretch">
    {children}
  </div>
);

export const SectionComparisonBeforeColumn = ({
  children,
  highlight = false,
}: {
  children: React.ReactNode;
  highlight?: boolean;
  isChanged?: boolean;
}) => {
  const backgroundClass = highlight
    ? 'bg-red-50 border border-red-200 dark:bg-red-900/20 dark:border-red-800'
    : 'bg-muted';

  return (
    <div
      className={`min-w-0 grow flex flex-col gap-2 col-start-2 py-4 px-6 justify-center ${backgroundClass}`}
    >
      {children}
    </div>
  );
};

export const SectionComparisonAfterColumn = ({
  children,
  highlight = false,
}: {
  children: React.ReactNode;
  highlight?: boolean;
  isChanged?: boolean;
}) => {
  const backgroundClass = highlight
    ? 'bg-green-50 border border-green-200 dark:bg-green-900/20 dark:border-green-800'
    : '';

  return (
    <div
      className={`min-w-0 grow flex flex-col gap-2 col-start-3 py-4 px-6 justify-center ${backgroundClass}`}
    >
      {children}
    </div>
  );
};

// Reusable section component
export const Section = ({
  children,
  title,
}: {
  children: React.ReactNode;
  title: string;
}) => (
  <div className="relative before:content-[''] before:absolute before:inset-0 before:rounded-xl before:border before:border-border before:pointer-events-none before:z-1 before:bg-muted">
    <div className="text-xs text-muted-foreground font-medium  px-6 py-3 z-[2] relative">
      {title}
    </div>
    <Card className="flex flex-col align-stretch justify-stretch gap-0 p-0 overflow-hidden z-[2] relative">
      {children}
    </Card>
  </div>
);
